import { Link } from "react-router-dom";

const plans = [
  {
    name: "Starter",
    price: "Free",
    detail: "Try the platform before you commit.",
    features: ["2 starter courses", "Progress tracking", "Community discussions"],
    cta: "Start Free Trial",
    featured: false,
  },
  {
    name: "Learner",
    price: "₹29/mo",
    detail: "The plan most students use.",
    features: ["All current courses", "Certificates", "Streaks and badges"],
    cta: "Enroll Now",
    featured: true,
  },
  {
    name: "Teams",
    price: "₹79/mo",
    detail: "Shared learning for a small group.",
    features: ["5 learner seats", "Team progress view", "Priority support"],
    cta: "Enroll Now",
    featured: false,
  },
];

function Pricing() {
  return (
    <main className="section-space">
      <div className="container">
        <div className="text-center mb-5">
          <h1>Simple pricing</h1>
          <p>Prices are in Indian rupees. Pick a plan and start learning today.</p>
        </div>
        <div className="row g-4">
          {plans.map((plan) => (
            <div className="col-md-6 col-lg-4" key={plan.name}>
              <article className={`price-card${plan.featured ? " featured" : ""}`}>
                <div className="price-card-body">
                  <h3>{plan.name}</h3>
                  <p className="plan-price">{plan.price}</p>
                  <p>{plan.detail}</p>
                  <ul>
                    {plan.features.map((feature) => (
                      <li key={feature}>{feature}</li>
                    ))}
                  </ul>
                  <Link to="/register" className="btn-accent">
                    {plan.cta}
                  </Link>
                </div>
              </article>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}

export default Pricing;
